// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"bab8492c","453":"c3b01c2e"}[chunkId] + ".chunk.js";
};